<template>
    <v-layout class="column" :class="{'pa-3': $vuetify.breakpoint.smAndDown, 'pa-4 ': $vuetify.breakpoint.mdAndUp}">
        <router-link :to="{name:'idea_detail', params: {id: content.id}}" class="link link--dark link--no-decor">
            <div :class="{'mb-2': $vuetify.breakpoint.smAndDown, 'title': $vuetify.breakpoint.smAndUp}">{{ content.title }}</div>
        </router-link>
        <v-layout row wrap align-center
                  mt-4
        >
            <v-flex pr-4 md2 xs7>
                <v-layout>
                    <div class="mr-2">{{ day(content.date) }}</div>
                    <div class="grey-text">{{ time(content.date) }}</div>
                </v-layout>
            </v-flex>
            <v-flex pr-2 md2 xs5>
                <v-layout>
                    <iconLabel :icon_name="content.liked ? 'heart-filled' : 'heart'" class="icon-label-red align-content-end" size="23"
                               :class="{'pr-3': $vuetify.breakpoint.xs}"
                               @click.native="like_idea(content.id)"
                    >{{ content.likes }}</iconLabel>
                    <router-link :to="{name:'idea_detail', params: {id: content.id}, hash:'#comments'}" class="link--anchor flex"><iconLabel icon_name="chat" class="icon-label-green" size="20">{{ content.comments }}</iconLabel></router-link>
                </v-layout>
            </v-flex>
            <v-flex v-if="!my_ideas" class="ideas-item__user" xl3
                    md4
                    xs12 :class="{'mt-2 pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}"
            >
                <div class="ideas-item__user-avatar">
                    <img v-if="content.author.avatar" :src="content.author.avatar" alt="avatar"
                         style="width: 40px;height: 40px;"
                    >
                </div>
                <v-layout column align-start>
                    <router-link class="link--anchor" :to="{name: 'profile_other', params: {id: content.author.id}}"><span>{{ content.author.name }}</span></router-link>
                    <v-layout align-center>

                        <img v-if="content.author.chevron" :src="content.author.chevron" alt="chevron"
                             class="mt-1"
                             width="30px" height="25px"
                        >
                        <div v-if="content.author.rank" class="grey-text">{{ content.author.rank }}</div> <div v-else class="grey-text">-</div>
                    </v-layout>
                </v-layout>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.mdAndUp" align-center md4
                    xl5
            >
                <iconLabel icon_name="idea" class="no_pointer grey-text" size="20">{{ content.theme }}</iconLabel>
            </v-flex>
        </v-layout>
        <div v-if="$vuetify.breakpoint.smAndUp" class="mt-3 grey-text" v-html="content.text"></div>
    </v-layout>
</template>

<script>
import iconLabel from '@/components/ui/icons/icon_with_label';
import dayjs from 'dayjs';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);
export default {
  components: {
    iconLabel,
  },
  props: {
    content: {
      type: Object,
    },
    my_ideas: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
  },
  methods: {
    ...mapMutations('ideas_bank', [
      'TO_LIKED',
    ]),
    ...mapActions('ideas_bank', [
      'like_idea',
      'unlike_idea',
    ]),
    day(date) {
      return new dayjs(parseInt(date)).format('DD.MM.YYYY');
    },
    time(date) {
      return new dayjs(parseInt(date)).format('HH.mm');
    },
  },

};
</script>
